import { r as registerInstance, h, H as Host } from './index-ih07wrgW.js';

const ProactiveCaseClosureModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.successMessageWasShown = false;
        /**
         * Environment to use for API calls
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * Debug mode
         * @deprecated do not use in production
         */
        this.debug = false;
        this.handleClose = () => {
            this.modal.triggerClose();
        };
        this.handleModalClose = () => {
            if (this.successMessageWasShown) {
                window.location.reload();
            }
        };
    }
    render() {
        return (h(Host, { key: '1c2495ea160d76f810c202056e2d5e78ac874ab7' }, h("ux-modal", { key: '734035572c6e70af9069a279e499048dde78584c', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '156d812159588ff32da0263cda6fc4a2137afc3f' }, h("mf-proactive-case-closure", { key: 'b8be411799dd58f21501333efd774a989e1f6c01', callId: this.callId, locale: this.locale, onMfServiceCallCancel: () => this.handleClose(), onMfServiceCallSuccess: () => {
                this.handleClose();
                window.location.reload();
            }, onMfServiceCallShowSuccess: () => (this.successMessageWasShown = true), env: this.env, legacyApi: this.legacyApi, debug: this.debug })))));
    }
};

export { ProactiveCaseClosureModal as mf_proactive_case_closure_modal };
//# sourceMappingURL=mf-proactive-case-closure-modal.entry.js.map

//# sourceMappingURL=mf-proactive-case-closure-modal.entry.js.map